import { showAnimation } from '../../../containers/BookingCalendar/FilterBar/DatePicker/DatePickerContainer'
import styled, { ITheme } from '../../../theme'

const Trangle = styled.div`
width: 0;
  animation: ${showAnimation} 0.2s linear forwards;
height: 0;
border-style: solid;
border-width: 0 15px 15px 15px;
border-color: transparent transparent ${(props: ITheme) =>
  props.theme.colors.primary}; transparent;
`

export default Trangle
